import { lazy, Suspense } from 'react';
import { Outlet, Route } from 'react-router-dom';

import Loading from '../../components/Loading';

import accountRouter from '../account';

const AlertDashboardComponent = lazy(
  () =>
    import(
      /* webpackChunkName: "alert-dashboard" */ '../../pages/alert-dashboard'
    ),
);

const alertDashboardRouter = (
  <Route path="alert-dashboard" element={<Outlet />}>
    <Route
      path=":projectId"
      element={
        <Suspense fallback={<Loading />}>
          <AlertDashboardComponent />
        </Suspense>
      }
    >
      {accountRouter()}
    </Route>
  </Route>
);

export default alertDashboardRouter;
